import React from "react"
// import { Link as RouterLink } from "react-router-dom"
import { useSnackbar } from "notistack"
import { API, graphqlOperation } from "aws-amplify"
import { getShortUrl } from "../graphqlCustom/queries"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"

import Button from "./Button"
import TextField from "./TextField"

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(5),
  },
  blankWrapper: {
    width: "100%",
  },
}))

const ViewEmail = ({ url }) => {
  const classes = useStyles()
  // const url = `https://staging.condoaxis.com/documents/${token}`
  const inputRef = React.useRef(null)
  const [copied, setCopied] = React.useState(false)
  const [shortUrl, setShortUrl] = React.useState("")
  const { enqueueSnackbar } = useSnackbar()
  // setShortUrl(url)

  // const shortUrl = url

  React.useEffect(() => {
    async function urlShortener() {
      try {
        const newUrl = await API.graphql(
          graphqlOperation(getShortUrl, {
            longUrl: url,
          })
        )
        if (newUrl.data.getShortUrl.link) {
          setShortUrl(newUrl.data.getShortUrl.link)
        } else {
          setShortUrl(url)
        }
      } catch (error) {
        console.log("error", error)
        enqueueSnackbar("Error fetching documents", {
          variant: "error",
        })
      }
    }
    urlShortener()
  }, [url, enqueueSnackbar])

  const copyToClipboard = (e) => {
    inputRef.current.select()
    document.execCommand("copy")
    // e.target.focus()
    setCopied(true)
    enqueueSnackbar("Copied to clipboard", {
      variant: "success",
    })
  }

  return (
    <Grid className={classes.root} container spacing={3}>
      <div className={classes.blankWrapper}>
        <Grid item xs={12}>
          <h3>Send this link</h3>
          <TextField
            value={shortUrl}
            onClick={copyToClipboard}
            readOnly
            inputProps={{ ref: inputRef }}
          />
          <Button onClick={copyToClipboard} style={{ marginTop: 16 }}>
            {!copied ? "Copy" : "Copied"}
          </Button>
          {/* <a href={url} targe="_blank">
              {url}
            </a> */}
        </Grid>
      </div>
    </Grid>
  )
}

export default ViewEmail
